"use client";
import { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import IconArrow from "assets/svg/chevron-down.svg";

import styles from "./styles.module.css";

const MoreContent = ({ children, defaultHeight }) => {
  const [contentOpened, setContentOpened] = useState(false);
  const [height, setHeight] = useState("auto");
  const [isActionButtonVisible, setIsActionButtonVisible] = useState(false);

  const ref = useRef(null);

  useEffect(() => {
    if (ref?.current?.clientHeight > defaultHeight + 15) {
      setHeight(defaultHeight);
      setIsActionButtonVisible(true);
    } else {
      setHeight("auto");
    }
  }, []);

  const wrapperClasses = classNames({
    [styles.wrapper]: true,
    [styles.isContentOpened]: contentOpened,
  });

  const actionClasses = classNames({
    [styles.action]: true,
    [styles.contentOpened]: contentOpened,
  });

  const handleActionButton = () => {
    setHeight(contentOpened ? defaultHeight : "auto");
    setContentOpened(!contentOpened);

    if (contentOpened) {
      const elementPosition = ref.current?.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - 240;
      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className={wrapperClasses}>
      <div className={styles.inner} style={{ height }} ref={ref}>
        {children}
      </div>
      {isActionButtonVisible && (
        <div className={actionClasses} onClick={handleActionButton}>
          {contentOpened ? "Daha Az Gör" : "Daha Fazla Gör"}
          <span className={styles.iconWrap}>
            <IconArrow />
          </span>
        </div>
      )}
    </div>
  );
};

MoreContent.propTypes = {
  children: PropTypes.node,
  defaultHeight: PropTypes.number,
};

export default MoreContent;
